// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__XMzS7","spinnerLoader":"Spinner_spinnerLoader__aZbI0","lds-ring":"Spinner_lds-ring__0vIq+"};